import '@core/sentry/instrument'; // Must be first — captures errors during module evaluation
import { createRoot } from 'react-dom/client'
import { initReservationAttribution } from '@shared/utils/reservationSource'
import { captureVisaDiningPreview } from '@features/booking/utils/visaDiningPreview'
import { initFullStory } from '@core/analytics/fullstory'
import { getEmbedContext } from '@core/embed'
import App from '@app/App'
import { fetchViewerCountry } from '@features/booking/utils/viewerCountry'
import './index.css'

// Normalize double slashes in pathname (e.g. //user/account → /user/account).
// Backend email templates sometimes produce URLs with double slashes.
// Must redirect (not replaceState) so the router initializes with the clean URL.
const { pathname } = window.location;
if (pathname.includes('//')) {
  const cleaned = pathname.replace(/\/\/+/g, '/');
  window.location.replace(cleaned + window.location.search + window.location.hash);
}

// Read how this page is embedded while the entry query string is still there.
getEmbedContext();

// Capture UTM params, referrer, and source from the landing URL before
// SPA navigation strips query params. Must run before React renders.
initReservationAttribution();

// Staging-only demo: capture ?previewVisaDining from the landing URL (before
// navigation strips it) so the Visa Dining Collection badge can be showcased.
// No-op in production.
captureVisaDiningPreview();

// Load FullStory session replay. No-ops in dev / preview where the env var
// is not set. Boot order: after Sentry (which intentionally goes first to
// capture module-eval errors) but before React renders, so the SDK has the
// earliest possible chance to start recording.
initFullStory(import.meta.env.VITE_FULLSTORY_ORG_ID);

// Resolve the visitor's country before the payment step, so its amounts don't switch under the guest.
void fetchViewerCountry();

createRoot(document.getElementById("root")!).render(<App />);
